import React, { Component } from 'react';
import Paper from '@material-ui/core/Paper';

class ContentPanel extends Component {
  constructor(props) {
    super(props);
    let row = this.props.row || 1;
    let col = this.props.column || 1;
    let rowSpan = this.props.rowSpan || 1;
    let colSpan = this.props.colSpan || 1;
    this.style = {
      msGridRow: row,
      msGridColumn: col,
      msGridColumnSpan: colSpan,
      msGridRowSpan: rowSpan,
      gridRow: `${row} ${rowSpan ? `/ span ${rowSpan}` : ""}`,
      gridColumn: `${col} ${colSpan ? `/ span ${colSpan}` : ""}`,
      margin: this.props.adder ? '0' : this.props.margin,
      padding: this.props.padding
    }
  }
  render() {
    return (
        this.props.noPaper ?
        <div id={this.props.id} style={{...this.style, ...this.props.style}} className={`content-panel ${this.props.className}`}>
          {this.props.children}
        </div>
        :
        <Paper id={this.props.id} style={{...this.style, ...this.props.style}}  className={`content-panel ${this.props.className}`}>
          {this.props.children}
        </Paper>
    )
  }
}
ContentPanel.defaultProps={
  noPaper: false,
  style: {},
  className: '',
  margin: '10px',
  padding: '10px'
}
export default ContentPanel;